import { Theme } from "@bluframe/blublocks"
import styled from "styled-components"

export const Wrapper = styled.div`
  align-items: start;
  background: ${({ theme }: { theme: Theme }) => theme.palette.text.contrast};
  display: grid;
  row-gap: 20px;
  width: 100%;

  & ul[aria-label="Images Carousel List"],
  ul[aria-label="Images Editing Carousel List"] {
    max-height: 250px;
  }
`
